import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { FreightTypeService } from 'app/services/freight-type.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-list-freight-type',
  templateUrl: './list-freight-type.component.html',
  styleUrls: ['./list-freight-type.component.css']
})
export class ListFreightTypeComponent implements OnInit {

  fTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;  
  lblHeading = '';

  popoverTitle = 'Delete Freight Type';
  popoverMessage = 'Are you sure you want to delete Freight Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Freight Type...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: FreightTypeService,
     private utility: UtilityServiceService,private toastService:ToastNotificationService, private toastr:ToastrService) { }

    ngOnInit() {
      this.onChangeHeandig();
      this.reload();
      this.utility.page = 1;
    }
  
    reload() {
      this.isLoading = true;
      this.service.getAll().subscribe(result => {
        this.fTypes = result;
        this.utility.onSort(1);     
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        this.isEmpty = true;
      });
    }
  
    onDelete(id: any) {
      this.service.delete(id).subscribe(result => {
        this.toastService.success(`Freight Type ${this.removeRef.code} deleted.`,'Delete Freight Type');
        if (result != null) {
          this.onNo();
          this.reload();
        }
        this.onChangeHeandig();
      }, error => {
        error = error.json();
        this.toastService.error(`Freight Type ${this.removeRef.code} was not deleted.`,'Delete Freight Type');
  
      });
    }
  
    onSort() {
      this.direction = !this.direction;
    }
  
    onConfirm(doc: any) {
      this.removeRef = doc;
      this.deleteConfirm = `Are you sure you want to delete Freight Type <strong>${this.removeRef.code}</strong>?`;        
      this.onChangeHeandig(false);
      this.isRemove = true;
    }
  
    onNo() {
      this.isRemove = false;
      this.onChangeHeandig();
    }
  
    onChangeHeandig(change: boolean = true) {
      this.lblHeading = (change) ? 'Freight Types' : 'Delete Freight Type';    
    }
}
